import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { firebaseAuth } from '../../context/Firebase';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const ProtectedRoute = ({ children }) => {
  const [user, loading, error] = useAuthState(firebaseAuth);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Give Firebase time to restore the persisted auth state
    const timer = setTimeout(() => {
      setIsInitializing(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // While initializing or loading, show spinner
  if (isInitializing || loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // If there's an auth error, redirect to login
  if (error) {
    console.error('Auth error:', error);
    return <Navigate to="/" replace />;
  }

  // If no user after loading is complete, redirect to login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
